import React, { useState, useEffect } from "react";
// import { getAllBlogs, getPopularBlogs } from "../Blogapi";
import { getAllBlogs } from "../../components/utility/utility";
import Header from "../../components/blog/Header";
import TrendingCarousel from "../../components/blog/TrendingCarousel";

function Blog() {
  // State to store the blog data
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const blogData = await getAllBlogs();
        setBlogs(blogData);
        setLoading(false);
      } catch (err) {
        console.error("Error fetching blogs:", err);
        setError("Failed to load blogs. Please try again later.");
        setLoading(false);
      }
    };

    fetchBlogs();
  }, []);

  useEffect(() => {
    if (window !== undefined) {
      window.scrollTo(0, 0);
    }
  }, []);

  if (loading) {
    return  <div style={{height:'100vh', background:"#fff"}}><div id="loader" class="loader"></div>;</div>
  }

  if (error) {
    return <p style={{ color: "red" }}>{error}</p>;
  }

  return (
    <div>
      <Header />
      <div className="compmainnew">
        <TrendingCarousel blogPosts={blogs} />
        {/* <Popular name="Popular" blogs={popularBlogs} /> */}
      </div>
    </div>
  );
}

export default Blog;